<template>
  <DynamicModal
    :showModal="showAddModal"
    :persistent="false"
    @clickOutside="closeModal"
    title="Add Expense"
    maxWidth="1000px"
  >
    <v-container fluid slot="title-buttons" class="py-1">
      <v-row justify="end">
        <v-btn
          icon
          depressed
          color="primary"
          @click="closeModal"
        >
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-row>
    </v-container>
    <v-container fluid slot="content">
      <v-form ref="addExpenseForm">
        <div v-if="showExpenseAmountType">
          <v-row class="mt-3">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="expenseName"
                label="Name"
                validate-on-blur
                outlined
                :rules="[required('Name')]"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="4" md="2">
              <FormattedNumberField
                label="Amount"
                :value="amount"
                :required="true"
                prepend-inner-icon="attach_money"
                @valueChange="(newValue) => this.amount = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6" sm="4" md="3" v-if="showExpenseAmountType">
              <ExpenseAmountTypesDropdownList
                :expenseAmountTypeId="expenseAmountTypeId"
                :isRequired="true"
                @expenseAmountTypeIdChange="(newValue) => this.expenseAmountTypeId = newValue"
              ></ExpenseAmountTypesDropdownList>
            </v-col>
            <v-col cols="6" sm="4" md="3">
              <ExpensesTypesDropdownList
                :expenseTypeId="expenseTypeId"
                :isRequired="true"
                @expenseTypeIdChange="expenseTypeIdChangeHandler"
              ></ExpensesTypesDropdownList>
            </v-col>
          </v-row>
        </div>
        <div v-if="!showExpenseAmountType">
          <v-row class="mt-3">
            <v-col cols="12" sm="6">
              <v-text-field
                v-model="expenseName"
                label="Name"
                validate-on-blur
                outlined
                :rules="[required('Name')]"
              ></v-text-field>
            </v-col>
            <v-col cols="6" sm="3">
              <FormattedNumberField
                label="Amount"
                :value="amount"
                :required="true"
                prepend-inner-icon="attach_money"
                @valueChange="(newValue) => this.amount = newValue"
              ></FormattedNumberField>
            </v-col>
            <v-col cols="6" sm="3">
              <ExpensesTypesDropdownList
                :expenseTypeId="expenseTypeId"
                :isRequired="true"
                @expenseTypeIdChange="expenseTypeIdChangeHandler"
              ></ExpensesTypesDropdownList>
            </v-col>
          </v-row>
        </div>
      </v-form>
    </v-container>
    <v-container fluid slot="buttons" class="pb-0 mb-0">
      <div class="row d-flex justify-end">
        <div class="col-6">
          <v-btn
            block
            depressed
            color="primary"
            @click="addExpense"
          >
            Add
          </v-btn>
        </div>
        <div class="col-6">
          <v-btn
            block
            depressed
            outlined
            @click="closeModal"
          >
            Cancel
          </v-btn>
        </div>
      </div>
    </v-container>
  </DynamicModal>
</template>

<script>
import DynamicModal from '@/components/dialogs/DynamicModal'
import ExpensesTypesDropdownList from '@/components/expenses/ExpensesTypesDropdownList'
import { required } from '@/lib/formValidations'
import ExpenseAmountTypesDropdownList from '@/components/expenses/ExpenseAmountTypesDropdownList'
import { FormattedNumberField } from '@/components/shared/textFields'

export default {
  components: {
    DynamicModal,
    ExpensesTypesDropdownList,
    ExpenseAmountTypesDropdownList,
    FormattedNumberField
  },
  props: [
    'showActive',
    'showExpenseAmountType'
  ],
  data () {
    return {
      showAddModal: false,
      expenseName: null,
      expenseTypeId: null,
      amount: null,
      expenseAmountTypeId: null
    }
  },
  methods: {
    required,
    expenseTypeIdChangeHandler (newExpenseTypeId) {
      this.expenseTypeId = newExpenseTypeId
    },
    showModal () {
      this.showAddModal = true
    },
    closeModal () {
      this.clearExpense()
      this.showAddModal = false
    },
    clearExpense () {
      this.expenseName = null
      this.expenseTypeId = null
      this.amount = null
      this.expenseAmountTypeId = null
      this.$refs.addExpenseForm.resetValidation()
    },
    addExpense () {
      if (this.$refs.addExpenseForm.validate()) {
        let newExpense = {
          active: this.showActive ? true : null,
          expenseName: this.expenseName,
          expenseTypeId: this.expenseTypeId,
          amount: this.amount,
          expenseAmountTypeId: this.showExpenseAmountType ? this.expenseAmountTypeId : null
        }
        this.$emit('addExpense', newExpense)
        this.clearExpense()
        this.showAddModal = false
      }
    }
  }
}
</script>
